import * as React from 'react'

const AutoCompleteLocations = (props: any) => (
  <div className='flex fit items-center mb1 on-hover w100' onClick={props.onSelect(props.item)}>
    <div className='ml2'>
      <p className='m0 h5 '>{props.item.fullAddress}</p>
    </div>
  </div>
)
export default AutoCompleteLocations



// WEBPACK FOOTER //
// ./src/components/riders/AutoCompleteLocations.tsx